<template>
    <div v-show="isLogin">
        <table style="width: 100%">
            <tr>
                <td align="center">
                    <h4 style="color: #0f673b; padding-top: 20px;">
                        เพิ่มข้อมูลเห็ด
                        </h4>
                    <div class="form-style-5">
                        <form method="post"  enctype="multipart/form-data" novalidate >

                            <fieldset>
                                <legend class="legend-left"><span class="number">1</span> ข้อมูลเห็ด</legend>
                                <input type="text" ref="mushroom_thai" placeholder="ชื่อเห็ดไทย">
                                <input type="text" ref="mushroom_science" placeholder="ชื่อวิทยาศาสตร์">
                                <label for="mushroom_type">ประเภทเห็ด:</label>
                                <select id="mushroom_type" ref="mushroom_type">
                                    <option value="unknown">ไม่ทราบ</option>
                                    <option value="poison">เห็ดพิษ</option>
                                    <option value="edible">เห็ดกินได้</option>
                                </select>
                            </fieldset>

                            <fieldset>
                                <legend class="legend-left"><span class="number">2</span> สถานที่เก็บหรือแหล่งข้อมูล</legend>
                                <input type="text" ref="mushroom_location" placeholder="สถานที่เก็บ">
                                <input type="text" ref="mushroom_source_data" placeholder="แหล่งข้อมูล">
                                <input type="text" ref="mushroom_note" placeholder="อื่นๆ">
                            </fieldset>

                            <input type="hidden" name="_csrf_token" id="_csrf_token"  v-bind:value=getAuthen.token  />

                            <fieldset>
                                <legend class="legend-left"><span class="number">3</span> ภาพเห็ด</legend>

                                <div class="dropbox" v-if="isInitial || isSaving">
                                    <input type="file" multiple="multiple" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file">
                                    <p v-if="isInitial">
                                        คลิก!! ที่นี่เพื่ออัพโหลดภาพ<br>
                                        <span style="color: tomato"> ชื่อภาพต้องเป็นภาษาอังกฤษหรือตัวเลขเท่านั้น <br>ถ้าเป็นภาษาไทยจะมีปัญหาในการอัพโหลด</span>

                                    </p>
                                    <p v-if="isSaving">
                                        Uploading {{ fileCount }} files...<br>
                                        <img src="../assets/loading.gif" width="32">
                                    </p>

                                </div>

                                <!--SUCCESS-->
                                <div v-if="isSuccess || countFilesUpload!=0">
                                    <h2 v-if="countFilesUpload">Uploaded {{ countFilesUpload }} file(s) successfully.</h2>
                                    <p>
                                         <a href="javascript:void(0)" @click="reset()"> <icon name="remove" style="color: red"></icon>  ลบภาพทั้งหมด</a>
                                        &nbsp;||&nbsp;
                                         <a href="javascript:void(0)" @click="addImage()"> <icon name="plus" style="color: green"></icon> เพิ่มภาพ</a>
                                    </p>
                                    <ul class="list-inline">
                                        <li v-for="item in uploadedFiles">
                                            <img :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName">
                                        </li>
                                    </ul>
                                </div>

                                <!--FAILED-->
                                <div v-if="isFailed">
                                    <h2>Uploaded failed.</h2>
                                    <p>
                                        <a href="javascript:void(0)" @click="reset()">Try again</a>
                                    </p>
                                    <pre>{{ uploadError }}</pre>
                                </div>

                            </fieldset>

                            <input type="button" value="บันทึก" @click="submitButtionClick"  />
                        </form>
                    </div>
                </td>
            </tr>
        </table>

    </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3
var randomstring = require('randomstring')

export default {
  /* ready () {
    if (this.getAuthen.token === null) {
      alert('not login')
      return
    }
  }, */
  created () {
    if (this.getAuthen.token === '') {
      window.location.replace('/')
    }
  },
  data: function () {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos[]',
      countFilesUpload: 0,
      uploadCode: null
    }
  },
  computed: {
    ...mapGetters([
      'getBaseUrl',
      'getAuthen'
    ]),
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },
    isLogin () {
      return this.getAuthen.token !== ''
    }
  },
  methods: {
    reset () {
      var that = this
      if (this.uploadCode === null) {
        return
      }
      const formData = new FormData()
      formData.append('upload_code', this.uploadCode)
      formData.append('token', this.getAuthen.token)
      axios.post(this.getUrlUploadDelete(), formData)
        .then(function (response) {
          // console.log(response.data.result)
          var result = response.data.result
          if (result === 'delete') {
            that.currentStatus = STATUS_INITIAL
            that.uploadedFiles = []
            that.uploadError = null
            that.countFilesUpload = 0
            that.uploadCode = null
          }
        })
        .catch(function (error) {
          // console.log(error.response)
          if (error.response) {
            that.currentStatus = STATUS_FAILED
            that.uploadError = error.response
          }
        })
    },
    addImage () {
      this.currentStatus = STATUS_INITIAL
    },
    save (formData) {
       // upload data to the server
      this.currentStatus = STATUS_SAVING
      var that = this
      axios.post(this.getUrlUpload(), formData)
         .then(function (response) {
           // console.log(response.data)
           // console.log('STATUS_SUCCESS=' + STATUS_SUCCESS)
           that.addUploadFile(response.data)
           that.currentStatus = STATUS_SUCCESS
         })
         .catch(function (error) {
           if (error.response) {
             that.currentStatus = STATUS_FAILED
             // console.log(JSON.stringify(error))
             that.uploadError = error.response
           }
         })
    },
    filesChange (fieldName, fileList) {
       // handle file changes
      if (!fileList.length) return
      // random number for check file upload in same time
      if (this.uploadCode === null) {
        this.uploadCode = this.getRandomString()
      }
      // alert(this.uploadCode)
      Array
         .from(Array(fileList.length).keys())
         .map(x => {
           // alert(fieldName+":"+fileList[x]+":"+fileList[x].name);
           const formData = new FormData()
           formData.append(fieldName, fileList[x], fileList[x].name)
           formData.append('hph_id', this.getAuthen.hph_id)
           formData.append('token', this.getAuthen.token)
           formData.append('upload_code', this.uploadCode)
           this.save(formData)
         })
    },
    getRandomString () {
      var options = {
        length: 16,
        charset: 'alphanumeric',
        capitalization: 'lowercase'
      }
      return randomstring.generate(options)
    },
    addUploadFile (uploadData) {
      this.countFilesUpload++
      // console.log(uploadData[0].url)
      var imageInfo = {
        url: uploadData[0].url,
        originalName: uploadData[0].originalName
      }
      this.uploadedFiles.push(imageInfo)
    },
    getUrlUpload () {
      return this.getBaseUrl + '/upload.php'
    },
    getUrlUploadDelete () {
      return this.getBaseUrl + '/upload_delete.php'
    },
    getUrlMushroomSave () {
      return this.getBaseUrl + '/mushroom_save.php'
    },
    resetForm () {
      this.$refs.mushroom_thai.value = ''
      this.$refs.mushroom_science.value = ''
      this.$refs.mushroom_type.value = 'unknown'
      this.$refs.mushroom_location.value = ''
      this.$refs.mushroom_source_data.value = ''
      this.$refs.mushroom_note.value = ''
    },
    submitButtionClick () {
      if (this.uploadCode === null) {
        return
      }

      var mushroomThai = this.$refs.mushroom_thai.value
      var mushroomScience = this.$refs.mushroom_science.value
      var mushroomType = this.$refs.mushroom_type.value
      var mushroomLocation = this.$refs.mushroom_location.value
      var mushroomSourceData = this.$refs.mushroom_source_data.value
      var mushroomNote = this.$refs.mushroom_note.value
      // alert('mushroomType=' + mushroomType)
      if (mushroomThai === '') {
        alert('กรุณาระบุชื่อเห็ดไทย...')
        return
      }
      if (this.countFilesUpload === 0) {
        alert('เลือกไฟล์อย่างน้อย 1 รูปภาพ...')
        return
      }
      var that = this
      const formData = new FormData()
      formData.append('upload_code', this.uploadCode)
      formData.append('token', this.getAuthen.token)
      formData.append('hph_id', this.getAuthen.hph_id)
      formData.append('mushroom_thai', mushroomThai)
      formData.append('mushroom_science', mushroomScience)
      formData.append('mushroom_type', mushroomType)
      formData.append('mushroom_location', mushroomLocation)
      formData.append('mushroom_source_data', mushroomSourceData)
      formData.append('mushroom_note', mushroomNote)
      axios.post(that.getUrlMushroomSave(), formData)
        .then(function (response) {
          console.log('===getUrlMushroomSave')
          console.log(response)
          console.log(response.data.result)
          var result = response.data.result
          if (result === 'success') {
            that.currentStatus = STATUS_INITIAL
            that.uploadedFiles = []
            that.uploadError = null
            that.countFilesUpload = 0
            that.uploadCode = null
            if (window.confirm('บันทึกข้อมูลเรียบร้อยแล้ว \nท่าต้องการล้างข้อมูลที่กรอกหรือไม่ ?')) {
              that.resetForm()
            }
          }
        })
        .catch(function (error) {
          // console.log(error.response)
          if (error.response) {
            that.currentStatus = STATUS_FAILED
            that.uploadError = error.response
          }
        })
    }
  },
  mounted () {
    this.reset()
    this.addImage()
    this.submitButtionClick()
    this.resetForm()
  },
  props: [
  ],
  components: {
    Icon
  }
}
</script>

<style>
    .legend-left{
        width: 100%;
        text-align: left;
    }
    .form-style-5{
        max-width: 500px;
        padding: 10px 20px;
        background: #f4f7f8;
        margin: 10px auto;
        padding: 20px;
        background: #f4f7f8;
        border-radius: 8px;
        font-family: Georgia, "Times New Roman", Times, serif;
        margin-top: 10px;
    }
    .form-style-5 fieldset{
        border: none;
    }
    .form-style-5 legend {
        font-size: 1.4em;
        margin-bottom: 10px;
    }
    .form-style-5 label {
        display: block;
        margin-bottom: 8px;
    }
    .form-style-5 input[type="text"],
    .form-style-5 input[type="date"],
    .form-style-5 input[type="datetime"],
    .form-style-5 input[type="email"],
    .form-style-5 input[type="number"],
    .form-style-5 input[type="search"],
    .form-style-5 input[type="time"],
    .form-style-5 input[type="url"],
    .form-style-5 textarea,
    .form-style-5 select {
        font-family: Georgia, "Times New Roman", Times, serif;
        background: rgba(255,255,255,.1);
        border: none;
        border-radius: 4px;
        font-size: 16px;
        margin: 0;
        outline: 0;
        padding: 7px;
        width: 100%;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        background-color: #e8eeef;
        color:#8a97a0;
        -webkit-box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
        box-shadow: 0 1px 0 rgba(0,0,0,0.03) inset;
        margin-bottom: 30px;

    }
    .form-style-5 input[type="text"]:focus,
    .form-style-5 input[type="date"]:focus,
    .form-style-5 input[type="datetime"]:focus,
    .form-style-5 input[type="email"]:focus,
    .form-style-5 input[type="number"]:focus,
    .form-style-5 input[type="search"]:focus,
    .form-style-5 input[type="time"]:focus,
    .form-style-5 input[type="url"]:focus,
    .form-style-5 textarea:focus,
    .form-style-5 select:focus{
        background: #d2d9dd;
    }
    .form-style-5 select{
        -webkit-appearance: menulist-button;
        height:35px;
    }
    .form-style-5 .number {
        background: #1abc9c;
        color: #fff;
        height: 30px;
        width: 30px;
        display: inline-block;
        font-size: 0.8em;
        margin-right: 4px;
        line-height: 30px;
        text-align: center;
        text-shadow: 0 1px 0 rgba(255,255,255,0.2);
        border-radius: 15px 15px 15px 0px;
    }

    .form-style-5 input[type="submit"],
    .form-style-5 input[type="button"]
    {
        position: relative;
        display: block;
        padding: 19px 39px 18px 39px;
        color: #FFF;
        margin: 0 auto;
        background: #1abc9c;
        font-size: 18px;
        text-align: center;
        font-style: normal;
        width: 100%;
        border: 1px solid #16a085;
        border-width: 1px 1px 3px;
        margin-bottom: 10px;
    }
    .form-style-5 input[type="submit"]:hover,
    .form-style-5 input[type="button"]:hover
    {
        background: #109177;
    }
    .input-text{
        width: 200px;
    }

    .dropbox {
        outline: 2px dashed grey; /* the dash box */
        outline-offset: -10px;
        background: lightcyan;
        color: dimgray;
        padding: 10px 10px;
        min-height: 200px; /* minimum height */
        position: relative;
        cursor: pointer;
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    .dropbox:hover {
        background: lightblue; /* when mouse over to the drop zone, change color */
    }

    .dropbox p {
        font-size: 1.2em;
        text-align: center;
        padding: 50px 0;
    }
</style>



// WEBPACK FOOTER //
// AddMushRoom.vue?2a4be864